// extracted by mini-css-extract-plugin
module.exports = {"color-pickers-container":"styles_color-pickers-container__DZ7AL"};